import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const BellSlashIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/bell-slash"><g id="Icon"><path d="M4.79998 9.60039C4.79998 9.28765 4.81992 8.97957 4.8586 8.67734L14.1256 17.9443C13.4217 17.9815 12.713 18.0004 12 18.0004C11.2142 18.0004 10.4338 17.9775 9.65918 17.9323C9.90119 19.0018 10.8573 19.8004 12 19.8004C13.0779 19.8004 13.9898 19.0899 14.2929 18.1116L15.654 19.4727C14.9318 20.7434 13.566 21.6004 12 21.6004C9.80908 21.6004 8.00996 19.9228 7.81714 17.782C6.4942 17.6431 5.19047 17.439 3.90925 17.173C3.63424 17.1159 3.40166 16.9337 3.2804 16.6803C3.15915 16.427 3.16312 16.1316 3.29115 15.8816C4.25551 13.9985 4.79998 11.8643 4.79998 9.60039Z" fill="currentColor" /><path d="M20.7196 16.6803C20.6961 16.7294 20.6684 16.7758 20.6371 16.8191L7.66737 3.84936C8.87288 2.93974 10.3734 2.40039 12 2.40039C15.9764 2.40039 19.2 5.62394 19.2 9.60039C19.2 11.8643 19.7445 13.9985 20.7088 15.8816C20.8368 16.1316 20.8408 16.427 20.7196 16.6803Z" fill="currentColor" /><path d="M3.93642 2.66399C3.58495 2.31252 3.0151 2.31252 2.66363 2.66399C2.31216 3.01547 2.31216 3.58532 2.66363 3.93679L20.0636 21.3368C20.4151 21.6883 20.985 21.6883 21.3364 21.3368C21.6879 20.9853 21.6879 20.4155 21.3364 20.064L3.93642 2.66399Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BellSlashIcon;